import { Star } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { LOCIZE_NS } from '@avanta/shared/constants/common';

type RatingProps = {
  rating: number;
  numberOfRatings: number;
};

export const Rating = ({ rating, numberOfRatings }: RatingProps): React.ReactElement | null => {
  const { t } = useTranslation(LOCIZE_NS.COMMON);
  if (numberOfRatings < 10) {
    return null;
  }
  const total = `(${numberOfRatings} ${t('Rating.total')})`;
  return (
    <div className="flex gap-1">
      <Star size={16} className="fill-denim-600" />
      <span className="text-sm font-semibold">{rating.toFixed(2)}</span>
      <span className="text-sm">{total}</span>
    </div>
  );
};
